export default __webpack_public_path__ + "static/media/2.cf18691d.png";